import { sendGa } from 'reactApp/utils/ga';

export const sendNewUserGa = (action = '', label = ''): void => {
    sendGa('new-user', action, label);
};
